module.exports = __webpack_public_path__ + "static/media/addForm.0c26ed6b.png";